import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const avatarDefaultVariants = {
  "size": "md",
  "variant": "circle",
  "disabled": false
}
const avatarCompoundVariants = [
  {
    "variant": "square",
    "size": "xs",
    "css": {
      "root": {
        "borderRadius": "4"
      },
      "badge": {
        "top": "-1px",
        "right": "-1px"
      }
    }
  },
  {
    "variant": "square",
    "size": "sm",
    "css": {
      "root": {
        "borderRadius": "4"
      },
      "badge": {
        "top": "-2px",
        "right": "-1px"
      }
    }
  },
  {
    "variant": "square",
    "size": "md",
    "css": {
      "root": {
        "borderRadius": "6"
      },
      "badge": {
        "top": "-3px",
        "right": "-2px"
      }
    }
  },
  {
    "variant": "square",
    "size": "lg",
    "css": {
      "root": {
        "borderRadius": "8"
      },
      "badge": {
        "top": "-3px",
        "right": "-2px"
      }
    }
  },
  {
    "variant": "square",
    "size": "xl",
    "css": {
      "root": {
        "borderRadius": "10"
      },
      "badge": {
        "top": "-3px",
        "right": "-3px"
      }
    }
  },
  {
    "variant": "circle",
    "size": "lg",
    "css": {
      "badge": {
        "top": "1px",
        "right": "1px"
      }
    }
  },
  {
    "variant": "circle",
    "size": "xl",
    "css": {
      "badge": {
        "top": "1px",
        "right": "1px"
      }
    }
  }
]

const avatarSlotNames = [
  [
    "wrapper",
    "avatar__wrapper"
  ],
  [
    "root",
    "avatar__root"
  ],
  [
    "text",
    "avatar__text"
  ],
  [
    "badge",
    "avatar__badge"
  ]
]
const avatarSlotFns = /* @__PURE__ */ avatarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, avatarDefaultVariants, getSlotCompoundVariant(avatarCompoundVariants, slotName))])

const avatarFn = memo((props = {}) => {
  return Object.fromEntries(avatarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const avatarVariantKeys = [
  "size",
  "variant",
  "disabled"
]
const getVariantProps = (variants) => ({ ...avatarDefaultVariants, ...compact(variants) })

export const avatar = /* @__PURE__ */ Object.assign(avatarFn, {
  __recipe__: false,
  __name__: 'avatar',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: avatarVariantKeys,
  variantMap: {
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "variant": [
    "circle",
    "square"
  ],
  "disabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, avatarVariantKeys)
  },
  getVariantProps
})